'use client';
import type { FC } from 'react';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';
import { css } from '@styled-system/css';

export const FreeBadge: FC = () => {
  const { session } = useTellerSession();
  if (!session || session?.tellerUser?.isVipUser) return null;
  return (
    <span
      className={css({
        display: 'inline-block',
        marginRight: '4px',
        padding: '2px 5px',
        color: 'primary',
        fontWeight: 'normal',
        fontSize: 'size_10',
        lineHeight: '1',
        verticalAlign: 'middle',
        background: 'tint',
        borderRadius: '10px',
        animation: 'fadein 200ms ease-in',
      })}
    >
      ¥0
    </span>
  );
};
